import React from 'react';


const PedigreeIFrame = (props) => {

    return (
        <iframe
            key={props.iframeKey}
            id="pedigree-iframe"
            title="Pedigree Viewer"
            src={props.iframeURL}
            onLoad={props.onLoad}
            style={{
                width: props.width || '50%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};

export default PedigreeIFrame;
